var lightBox = function(content,callback){
	var lightbox = $('<div>',{'id':'lightBox'});
	var	frame = $('<div>',{'class':'frame'});
	var close = $('<div>',{'class':'close'});	
    frame.append(close);
	lightbox.append(frame);
    frame.append(content);
    lightbox.hide().appendTo('body');
    lightbox.fadeIn();
    if(typeof callback == 'function'){
    	callback()
    }
    if(content.outerHeight() > lightbox.height()){
        content.addClass('overflow')
    }
    body.addClass('vidbox-open');
    body.trigger('lightbox-open');

    //close lightbox on pressing esc key
    $(document).keyup(function(e){
        if (e.keyCode === 27){
            close.click();
        }
    });
    
    close.click(function(){
    	lightbox.fadeOut();
    	body.removeClass('vidbox-open');
    	setTimeout(function(){
    		lightbox.empty().remove();
    	},300);
    });
}


// WEBPACK FOOTER //
// ./scripts/partials/_lightBox.js